import { Grid, TextField } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import RegularButton from "components/CustomButtons/Button";
import { ModalV2 } from "components/Modal/ModalV2";
import { useForm } from "hooks/useForm";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setUnitTransfer } from "redux/actions/unitsSection/unitsAction";
import { PERMISSIONS } from "router/permissions";

export const ModalUnitTransfer = ({ open, onClose, original }) => {
  const dispatch = useDispatch();
  const { stationsParent, company } = useSelector(
    ({ unitsReducer }) => unitsReducer
  );
  const { isLoadingComp } = useSelector(({ search }) => search);
  const { rules } = useSelector(({ login }) => login);
  let ruleStation = rules.includes(PERMISSIONS.UNIT_OPERATIVE_STATION)
  let ruleOperating = rules.includes(PERMISSIONS.UNIT_OPERATIVE)
  const {
    inputValues: { idStation, idOperating, blockOperating, blockStation },
    handleNewValues,
    fieldErrors,
    runValidates
  } = useForm(
    { idStation: null, idOperating: null, blockOperating: !stationsParent.length ? true : false, blockStation: false },
    { idOperating: { required: true } }
  );

  const handleSubmit = () => {
    if (runValidates()) return;
    dispatch(
      setUnitTransfer(
        {
          idUnit: original.id,
          idStation: idStation?.value || null,
          idOperating: idOperating?.value
        },
        onClose
      )
    );
  };

  useEffect(() => {
    !idStation && handleNewValues({ idOperating: null, blockOperating: !stationsParent.length ? true : false, blockStation: false  });
  }, [idStation]);

  return (
    <ModalV2
      open={open}
      onClose={onClose}
      title="Cambiar Planta/Unidad Operativa"
      isLoading={isLoadingComp?.loadingUnitsTransfer}
    >
      <Grid
        container
        spacing={2}
        style={{
          alignItems: "center"
        }}
      >
        <Grid item xs={12}>
          <TextField
            label="Numero Economico"
            variant="outlined"
            value={original?.number}
            fullWidth
            size="small"
          />
        </Grid>
        <Grid item xs={12} >
          <TextField
            label="P. Operativa Actual"
            variant="outlined"
            fullWidth
            value={original?.uStation || ""}
            size="small"
          />
        </Grid>
        <Grid item xs={12} >
          <TextField
            label="U. Operativa Actual"
            variant="outlined"
            fullWidth
            value={stationsParent.find(st => st.id ===  original?.idOperating)?.label}
            size="small"
          />
        </Grid>
        {
          ruleStation && 
          <Grid item xs={12}>
          <Autocomplete
            id="input-station-transfer"
            value={idStation}
            options={company?.stations.filter(st => st.id !== original?.idStation)}
            getOptionLabel={option => option.label || ""}
            onChange={(e, v) => handleNewValues({ idStation: v, idOperating: v, blockOperating: true })}
            renderInput={params => (
              <TextField
                {...params}
                label="Transferir a Planta:"
                variant="outlined"
                fullWidth
                size="small"
                disabled={blockStation}
              />
            )}
            fullWidth
            noOptionsText={"No hay resultados"}
            style={{ marginRight: 24 }}
            error={fieldErrors?.idStation}
            helperText={fieldErrors?.idStation}
            // onClose={() => handleNewValues({blockOperating: false})}
          />
        </Grid>
        }
        {
          ruleOperating && 
          <Grid item xs={12}>
          <Autocomplete
            id="input-units-transfer"
            value={idOperating}
            options={stationsParent.filter(st => st.id !==  original?.idOperating)}
            getOptionLabel={option => option.label || ""}
            onChange={(e, v) => handleNewValues({ idOperating: v, blockStation: true })}
            renderInput={params => (
              <TextField
                {...params}
                label="Transferir a Unidad Operativa:"
                variant="outlined"
                fullWidth
                size="small"
                disabled={blockOperating}
                helperText={idOperating || !blockOperating ? null : "* No cuenta con Unidades Operativas para transferir"}
              />
            )}
            fullWidth
            noOptionsText={"No hay resultados"}
            style={{ marginRight: 24 }}
            error={fieldErrors?.idOperating}
            helperText={fieldErrors?.idOperating}
            disabled={blockOperating}
          />
        </Grid>
        }
        <Grid item xs={12} style={{display: 'flex', justifyContent: 'flex-end', gap: 8}}>
          <RegularButton color="transparent" onClick={onClose}>
            cancelar
          </RegularButton>
          <RegularButton color="info" onClick={handleSubmit}>
            Transferir
          </RegularButton>
        </Grid>

      </Grid>
    </ModalV2>
  );
};
